import { makeStyles } from '@mui/styles';
import { Colors } from '../../layout/theme-next';
import { NextTheme } from '../../layout/theme-next/provider';

export default makeStyles<NextTheme>(() => ({
  buttonFullscreen: {
    marginLeft: 'auto',
  },
  clearRightBorder: {
    borderRight: 'none !important',
  },
  cellARHeader: {
    '& .k-link': {
      justifyContent: 'center',
    },
    '& .k-column-title': {
      whiteSpace: 'normal',
      textAlign: 'center',
    },
  },
  cellAR: {
    textAlign: 'center !important' as 'center',
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
  },
  fullScreen: {
    height: '100%',
  },
  dialogContentStyle: {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'visible',
    flex: 1,
  },
  error: {
    color: Colors.error,
    fontSize: 12,
  },
  iconContainer: {
    display: 'flex',
    alignSelf: 'end',
  },
  dialogPaper: {
    overflow: 'visible',
  },
}));
